import { useMemo } from "react";

type Props = {
	year: number;
	month: number;

	prevActionChildren: React.ReactNode;
	nextActionChildren: React.ReactNode;
};

export const CalendarHeader = ({ year, month, prevActionChildren, nextActionChildren }: Props) => {
	const titleText = useMemo(() => `${year}年${month}月`, [month, year]);

	return (
		<div className="flex w-full items-center justify-between px-3 py-4">
			{prevActionChildren}

			<div>
				<h5 className="text-xl font-semibold">{titleText}</h5>
			</div>

			{nextActionChildren}
		</div>
	);
};
